export const engagementAppGroupIdListEmailSettings = "/engagement/:app_group_id/list_email_settings";
